function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import getCookie from '../util/getCookie';
import domExists from '../dom/domExists';
import handleError from '../util/handleError';
let hasInitBeenCalled = false;
const MIXPANEL_ID_COOKIE_NAME = 'domain-mixpanel-id';
const MIXPANEL_COOKIE_DOMAIN = 'domain.com.au';
const replaceHistoryState = urlParams => {
  const search = urlParams.toString();
  window.history.replaceState(null, '', search ? "?".concat(search) : window.location.pathname);
};
function mixpanelProcessAuthActions(mixpanel, mixpanelToken, userDataOrPromise) {
  if (typeof URLSearchParams === 'undefined') {
    return;
  }
  const urlParams = new URLSearchParams(window.location.search);
  const _ref = [...urlParams.entries()].find(_ref3 => {
      let _ref4 = _slicedToArray(_ref3, 1),
        key = _ref4[0];
      return key.toLowerCase() === 'authaction';
    }) || [],
    _ref2 = _slicedToArray(_ref, 2),
    authActionKey = _ref2[0],
    authAction = _ref2[1];
  if (authAction === 'logout') {
    if (authActionKey) {
      urlParams.delete(authActionKey);
    }
    replaceHistoryState(urlParams);
    mixpanel.track('Logout');
    mixpanel.reset();
    document.cookie = "".concat(MIXPANEL_ID_COOKIE_NAME, "_").concat(mixpanelToken, "=; expires=Thu, 01 Jan 1970 00:00:00 GMT");
    return;
  }
  const handleData = userData => {
    const _ref5 = userData || {},
      userId = _ref5.userId,
      sessionToken = _ref5.sessionToken;
    if (sessionToken) {
      mixpanel.register({
        sessionToken
      });
    }
    if (!userId) {
      mixpanel.register({
        loggedIn: false
      });
      return;
    }
    mixpanel.register({
      loggedIn: true
    });
    if (authAction && ['signup', 'login'].includes(authAction)) {
      mixpanel.identify(userId ? "".concat(userId) : undefined);
      mixpanel.track(authAction === 'login' ? 'Login' : 'Signup');
      if (authActionKey) {
        urlParams.delete(authActionKey);
      }
      replaceHistoryState(urlParams);
      mixpanel.people.set({
        profileID: userId
      });
    }
  };
  if (userDataOrPromise instanceof Promise) {
    userDataOrPromise.then(handleData).catch(error => {
      handleError(error, {
        customData: {
          message: 'Failed to resolve user data in fe-helper#initMixpanel.'
        }
      });
    });
  } else {
    handleData(userDataOrPromise);
  }
}
export function initMixpanel(mixpanel, mixpanelToken, userDataOrPromise) {
  let customCookieDomain = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : MIXPANEL_COOKIE_DOMAIN;
  if (!domExists() || hasInitBeenCalled) {
    return;
  }
  const cannotTrack = getCookie('domain-dt') === '1';
  mixpanel.init(mixpanelToken, {
    batch_requests: true,
    persistence: 'localStorage',
    opt_out_tracking_by_default: cannotTrack
  });
  if (!cannotTrack && mixpanel.has_opted_out_tracking()) {
    mixpanel.clear_opt_in_out_tracking();
  }
  const mixpanelDistinctId = getCookie("".concat(MIXPANEL_ID_COOKIE_NAME, "_").concat(mixpanelToken));
  if (mixpanelDistinctId && mixpanelDistinctId !== mixpanel.get_distinct_id()) {
    mixpanel.alias(mixpanelDistinctId);
  } else {
    window.document.cookie = "".concat(MIXPANEL_ID_COOKIE_NAME, "_").concat(mixpanelToken, "=").concat(mixpanel.get_distinct_id(), ";domain=").concat(customCookieDomain, ";expires=Wed, 19 May 2100 00:00:00 GMT;path=/;secure");
  }
  mixpanelProcessAuthActions(mixpanel, mixpanelToken, userDataOrPromise);
  hasInitBeenCalled = true;
  if (typeof window !== 'undefined' && window.mixpanel !== mixpanel) {
    window.browserMixpanel = mixpanel;
  }
}
export function getMixpanel() {
  if (domExists() && window.mixpanel) {
    return window.mixpanel;
  }
  if (domExists() && window.browserMixpanel) {
    return window.browserMixpanel;
  }
  try {
    const mixpanel = require('mixpanel-browser');
    if (mixpanel.__esModule === true) {
      return mixpanel.default;
    }
    return mixpanel;
  } catch (error) {
    return null;
  }
}